import * as React from 'react';
import * as queryString from 'query-string';
import OrdersTable from './OrdersTable';
import { RouteComponentProps, withRouter } from 'react-router';

interface IOrdersProps extends RouteComponentProps<{ eshop: string, customerId: string }> { }

class Orders extends React.Component<IOrdersProps> {

  state = {
    loading: false,
    status: 'pending',
    searchQuery: ''
  };

  constructor(props: any) {
    super(props);
  }

  public render() {
    return (
      <div>
        <OrdersTable
          customerId={this.props.match.params.customerId}
          domain={this.props.match.params.eshop}
          onNewOrder={() => this.onNewOrder()}
          onEditOrder={val => this.onEditOrder(val)}
          searchQuery={this.state.searchQuery}
          filter={queryString.parse(this.props.location.search)}
          onSearch={filter => this.changeSearchQuery(filter)}
        />
      </div>
    );
  }

  private onNewOrder() {
    const eshop = this.props.match.params.eshop;
    this.props.history.push(`/${eshop}/application/order/new`);
  }

  private onEditOrder(orderId: string) {
    const eshop = this.props.match.params.eshop;

    this.props.history.push(`/${eshop}/application/order/${orderId}`);
  }

  private changeSearchQuery(searchQuery: any) {
    const qs = queryString.stringify(searchQuery);
    this.props.history.push(`?${qs}`);
    this.setState({ searchQuery });
  }
}

export default withRouter(Orders);



// WEBPACK FOOTER //
// ./src/scenes/Orders/index.tsx